module.exports = __webpack_public_path__ + "img/3_james_h.28dfb581.png";